import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiKeyService } from 'src/app/services/api-key.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { ApiKeyActions, ApiKeyActionTypes } from '../actions/api-key.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ApiKeyEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private apikeyService = inject(ApiKeyService);
  private injector = inject(Injector);


  constructor() {}

  ReadApiKeys$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ApiKeyActionTypes.GetApiKeys),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadApiKey
      };
      const param = {
        otp: user.otp
      }
      return this.apikeyService.ReadApiKeys(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertApiKey(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction(updateRes)];
          } else {
            return [new featureActions.GetApiKeysFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.GetApiKeysFail()];
        })
      );
    })
  ));
  AddApiKey$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ApiKeyActionTypes.AddApiKey),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddApiKey
      };
      const payload = { ...action.payload, otp: user.otp };
      return this.apikeyService.AddApiKey(payload).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.GetApiKeys(),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: this.injector.get(TranslateService).instant('Add Api Key Success'), result: true })];
          } else {
            return [new featureActions.AddApiKeyFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        catchError((error) => {
            return [new featureActions.AddApiKeyFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error.error.errmsg.body })];
        })
      );
    })
  ));
  UpdateApiKey$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ApiKeyActionTypes.UpdateApiKey),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateApiKey
      };
      const payload = { ...action.payload, otp: user.otp };
      return this.apikeyService.UpdateApiKey(payload).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.GetApiKeys(),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.UpdateApiKeyFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.UpdateApiKeyFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.UpdateApiKeyFail()];
        })
      );
    })
  ));
  DeleteApiKey$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ApiKeyActionTypes.DeleteApiKey),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteApiKey
      };
      const payload = { ...action.payload, otp: user.otp };
      return this.apikeyService.DeleteApiKey(payload).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.GetApiKeys(),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.DeleteApiKeyFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.DeleteApiKeyFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.DeleteApiKeyFail()];
        })
      );
    })
  ));
  ReadApiKeyUsage$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ApiKeyActionTypes.GetApiKeyUsage),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadApiKeyUsage
      };
      const payload = { ...action.payload, otp: user.otp };
      return this.apikeyService.ReadApiKeyUsage(payload).pipe(
        switchMap((res: any) => {
          if (res.msg.body) {
            return [new featureActions.UpsertApiKeyUsage(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.GetApiKeyUsageFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
